import hasClass from './hasClass';
export default function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}


//////////////////
// WEBPACK FOOTER
// ../~/dom-helpers/esm/addClass.js
// module id = 2587
// module chunks = 121